<template>
    <grid :rowData="items" :columnDefs="columnDefs" :saveRowOrder="saveRowOrder" :isSearch="false">
        <busy-modal :show="busy"></busy-modal>
        <responsive-button
            @click="$bvModal.show('create-subcategory')"
            variant="primary"
            title="Add Subcategory"
            :icon="['fas', 'plus']"
        >
            Add Subcategory
        </responsive-button>
        <validation-observer v-slot="{ meta, setValues }" ref="add_subcategory_form">
            <modal
                ok-title="Save"
                id="create-subcategory"
                title="Add Subcategory"
                @ok.prevent="createSubCategory"
                :ok-disabled="!meta.valid"
                @hidden="subCategoryName = ''"
                :hide-backdrop="true"
                dialog-class="subcategory-centered-modal"
            >
                <validation-provider name="name" v-slot="{ errors }" rules="required" >
                    <form-input
                        :floating-label="labelName"
                        v-model="subCategoryName"
                        :error="errors[0]"
                        @input="(val) => setValues({ name: val })"
                    ></form-input>
                </validation-provider>
            </modal>
        </validation-observer>
    </grid>
</template>

<script>
    import Grid from '../../generic/grid/grid.vue';
    import ActionsSubCategoryCellRenderer from './subcategory-action-cell-renderer.vue';
    import API from '../../../api';
    import {
        PROPERTY_SUBCATEGORY_ENDPOINT,
        PROPERTY_SUBCATEGORY_DELETE_ENDPOINT,
        PROPERTY_SUBCATEGORY__ORDER_ENDPOINT,
    } from '../../../endpoints';
    import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
    import Modal from '../../generic/modal/modal.vue';
    import FormInput from '../../generic/form-input/form-input.vue';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';

    export default {
        name: 'PropertyCategoriesList',
        components: {
            Grid,
            ResponsiveButton,
            Modal,
            FormInput,
            BusyModal,
            actionsSubCategoryCellRenderer: ActionsSubCategoryCellRenderer,
        },
        props: {
            categoryId: Number,
        },
        data() {
            return {
                subCategoryName: null,
                labelName: 'Subcategory name',
                busy: null,
                items: [],
                columnDefs: [],
            };
        },
        mounted() {
            this.fetchSubCategories();
            this.columnDefs = [
                {
                    field: 'order',
                    headerName: 'Order',
                    flex: 1,
                    maxWidth: 200,
                    sort: 'asc',
                    rowDrag: true,
                    rowDragText: ({ defaultTextValue, rowNode }) => `${defaultTextValue} ${rowNode.data.name}`,
                },
                {
                    field: 'name',
                    headerName: 'Name',
                    flex: 2,
                    resizable: false,
                },
                {
                    field: '',
                    cellRenderer: 'actionsSubCategoryCellRenderer',
                    maxWidth: 150,
                    minWidth: 150,
                    sortable: false,
                    resizable: false,
                    cellStyle: {
                        display: 'flex',
                        justifyContent: 'center',
                    },
                    cellRendererParams: {
                        update: () => {
                            this.fetchSubCategories();
                        },
                        categoryId: this.categoryId,
                    },
                },
            ];
        },
        methods: {
            async createSubCategory() {
                try {
                    await API.post(PROPERTY_SUBCATEGORY_ENDPOINT(), {
                        name: this.subCategoryName,
                        labelName: this.labelName,
                        category_id: this.categoryId,
                    });
                    await this.fetchSubCategories();
                    this.$bvModal.hide('create-subcategory');
                } catch (e) {
                    this.errorToast({ text: 'Could not create subcategory' });
                }
            },
            async fetchSubCategories() {
                try {
                    this.busy = true;
                    const { data } = await API.get(PROPERTY_SUBCATEGORY_ENDPOINT(this.categoryId));
                    this.items = data;
                } catch (e) {
                    this.errorToast({ text: 'Could not load data' });
                } finally {
                    this.busy = false;
                }
            },
            async saveRowOrder({ row, order, onSuccess, onError }) {
                try {
                    onSuccess();
                    const requestBody = this.items.map((item) => {
                        return {
                            id: item.id,
                            order: item.order,
                        };
                    });
                    await API.put(PROPERTY_SUBCATEGORY__ORDER_ENDPOINT(this.categoryId), requestBody);
                } catch (e) {
                    onError(error);
                }
            },
        },
    };
</script>

<style>
    .ag-dnd-ghost {
        z-index: 2000 !important;
    }
</style>
